// Matching constants defined in https://gitlab.tcc.li/climate/cfvweb/crop-planning/-/blob/main/src/constants/stash.ts
export const CROP_PLAN_INTEGRATION = {
  project: 'crop-planning',
  key: 'prescription-creation',
  queryParamKey: 'isCropPlanningIntegration'
} as const;
